/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-lines-per-function */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { DialogService } from 'nebula-ui-kit';
import {
  ConceptosFacturacionModal,
  ConceptosFacturacionService,
} from './conceptos-facturacion.service';
import { lastValueFrom, map, Observable } from 'rxjs';
import { SelectDialogComponent } from '../../../select-dialog/select-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConceptosFacturacionModalService {
  readonly dialogService = inject(DialogService);
  readonly conceptosFacturacionService = inject(ConceptosFacturacionService);

  openSelector(
    title: string,
    currentValue?: string,
    soloActivos = true,
  ): Observable<ConceptosFacturacionModal | null> {
    const columns = [
      {
        key: 'codigo',
        label: 'Código',
        sortable: true,
        width: '30%',
      },
      {
        key: 'nombreConcepto',
        label: 'Nombre',
        sortable: true,
        width: '40%',
      },
      {
        key: 'tipoConcepto',
        label: 'Tipo',
        sortable: true,
        width: '15%',
      },
      {
        key: 'estadoConcepto',
        label: 'Estado',
        sortable: true,
        width: '15%',
        displayFn: (item: any) => {
          return item.estadoConcepto || 'N/A';
        },
      },
    ];

    const loadDataFn = async (params: any): Promise<{ data: any[]; total: number }> => {
      try {
        const page = params.page - 1;
        const size = params.limit;
        const searchTerm = params.search || '';

        const response = await lastValueFrom(
          this.conceptosFacturacionService.getConceptosFacturacionPaginados(
            page,
            size,
            searchTerm,
            soloActivos,
          ),
        );

        return {
          data: response.content,
          total: response.totalElements,
        };
      } catch (error) {
        return { data: [], total: 0 };
      }
    };

    const dialogRef = this.dialogService.open(SelectDialogComponent, {
      data: {
        title: title,
        columns: columns,
        multiSelect: false,
        searchPlaceholder: 'Buscar por código o nombre...',
        loadDataFn: loadDataFn,
        itemIdKey: 'id',
        selectedItems: currentValue ? [{ id: currentValue }] : [],
        displayFn: (item: any) => {
          const codigo = item.codigo || '';
          const nombre = item.nombreConcepto || item.nombre || '';
          const tipo = item.tipoConcepto || '';
          const estado = item.estadoConcepto || '';

          let displayText = `${codigo} - ${this.truncateText(nombre, 30)}`;
          if (tipo) {
            displayText += ` (${tipo})`;
          }
          if (estado) {
            displayText += ` - ${estado}`;
          }
          return displayText;
        },
      },
      size: 'lg',
      width: '800px',
    });

    return dialogRef.afterClosed().pipe(
      map((selected: ConceptosFacturacionModal[]) => {
        return selected && selected.length > 0 ? selected[0] : null;
      }),
    );
  }

  truncateText(text: string, maxLength = 20): string {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }
}
